import styled, { keyframes } from "styled-components";

const shine = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
`;

const MainTitle = styled.h1`
  font-size: ${({ fontSize }) => fontSize || "24px"};
  font-weight: 800;
  font-family: "Run Medium", sans-serif;
  // background: linear-gradient(300deg, #c81d25 0%, #FB6186 25%, #c81d25 50%, #FB6186 75%, #c81d25 100%);
  // background: linear-gradient(300deg, #000 0%, #d0d0e2 25%, #000 50%, #d0d0e2 75%, #000 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: #000;
  background-size: 150% auto;
  animation: ${shine} 4s ease-in-out infinite alternate;
`;

export default function Logo({ fontSize = "0.8em" }) {
  return <MainTitle fontSize={fontSize}>prae</MainTitle>;
}
